export enum ScanEntityTypes {
  POSTER = 'POSTER',
  PRESENTATION = 'PRESENTATION',
  SESSION = 'SESSION',
  SPONSOR = 'SPONSOR',
  LOUNGE = 'LOUNGE',
  SPONSOR_LOUNGE = 'SPONSOR_LOUNGE',
  EVENT_PLATFORM = 'EVENT_PLATFORM',
}
